const LINES_TYPE_ID = 1
const BARS_WITH_LINES_TYPE_ID = 2
const X_AXIS_TYPE_ID = 3
export const TABLE_TYPE_ID = 4
const COUNTER_TYPE_ID = 5
const CHART_SPEEDOMETER = 6
const CHART_QUEUE = 7
const EXTENSION_CARDS = 9
const HISTORY_COUNTERS = 10
const QUEUE_DASHBOARD = 11
const QUEUE_ACTIVE_CALL = 12
const EXTERNAL_DATA_TYPE_ID = 13
const QUEUE_COUNTER_TYPE_ID = 14
const PIE_TYPE_ID = 15
const RICH_TEXT_EDITOR_ID = 16
const TOTAL_OUTGOING_CALLS = 17
const CHART_AREA_ID = 18
const RICH_TEXT_EDITOR_LIST = 19
const AVERAGE_CALLS_DURATION = 20
export const INFO_TYPE_ID = 22
const DIALERS_TYPE_ID = 21
const FUNNEL_3D_TYPE_ID = 33
const EXTENSION_CARDS_STATISTICS = 24

export default {
    LINES_TYPE_ID,
    BARS_WITH_LINES_TYPE_ID,
    X_AXIS_TYPE_ID,
    TABLE_TYPE_ID,
    COUNTER_TYPE_ID,
    CHART_SPEEDOMETER,
    CHART_QUEUE,
    EXTENSION_CARDS,
    HISTORY_COUNTERS,
    QUEUE_DASHBOARD,
    QUEUE_ACTIVE_CALL,
    EXTERNAL_DATA_TYPE_ID,
    QUEUE_COUNTER_TYPE_ID,
    PIE_TYPE_ID,
    RICH_TEXT_EDITOR_ID,
    TOTAL_OUTGOING_CALLS,
    CHART_AREA_ID,
    RICH_TEXT_EDITOR_LIST,
    AVERAGE_CALLS_DURATION,
    INFO_TYPE_ID,
    FUNNEL_3D_TYPE_ID,
    DIALERS_TYPE_ID,
    EXTENSION_CARDS_STATISTICS
}

export const TABLE_DATA_TYPES = [
    TABLE_TYPE_ID,
    QUEUE_DASHBOARD,
    DIALERS_TYPE_ID,
    RICH_TEXT_EDITOR_LIST,
    QUEUE_ACTIVE_CALL
]

export const templateIcons = {
    [LINES_TYPE_ID]: 'IconTemplateChart',
    [BARS_WITH_LINES_TYPE_ID]: 'IconTemplateChart',
    [X_AXIS_TYPE_ID]: 'IconTemplateChart',
    [TABLE_TYPE_ID]: 'IconTemplateTable',
    [COUNTER_TYPE_ID]: 'IconTemplateCounter',
    [CHART_SPEEDOMETER]: 'IconTemplateCounter',
    [CHART_QUEUE]: 'IconTemplateChart',
    [EXTENSION_CARDS]: 'IconTemplateCounter',
    [HISTORY_COUNTERS]: 'IconTemplateCounter',
    [QUEUE_DASHBOARD]: 'IconTemplateChart',
    [QUEUE_COUNTER_TYPE_ID]: 'IconTemplateCounter',
    [QUEUE_ACTIVE_CALL]: 'IconTemplateChart',
    [EXTERNAL_DATA_TYPE_ID]: 'IconTemplateDefault',
    [INFO_TYPE_ID]: 'IconTemplateDefault',
    [PIE_TYPE_ID]: 'IconTemplatePie',
    [RICH_TEXT_EDITOR_ID]: 'IconTemplateDefault',
    [TOTAL_OUTGOING_CALLS]: 'IconTemplateCounter',
    [CHART_AREA_ID]: 'IconTemplatePie',
    [RICH_TEXT_EDITOR_LIST]: 'IconTemplateDefault',
    [AVERAGE_CALLS_DURATION]: 'IconTemplateCounter',
    [FUNNEL_3D_TYPE_ID]: 'IconTemplatePie',
    [DIALERS_TYPE_ID]: 'IconTemplateDefault',
    [EXTENSION_CARDS_STATISTICS]: 'IconTemplateCounter'

}

